<template>
    <div class="trainees-awards">
        <div class="trainees-awards__content">
            <h2 v-html="title"></h2>
            <p class="trainees-awards__description" v-html="description"></p>
        </div>
        <div class="container">
            <div class="row">
                <div class="trainees-awards__col col-l-4 col-m-12" v-html="first"></div>
                <div class="trainees-awards__col col-l-4 col-m-12" v-html="second"></div>
                <div class="trainees-awards__col col-l-4 col-m-12" v-html="third"></div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: ["blockdata"],
    name: "block-trainees-awards",
    data() {
        return {
            title: this.blockdata.title,
            description: this.blockdata.description,
            first: this.blockdata.first_column,
            second: this.blockdata.second_column,
            third: this.blockdata.third_column
        };
    },
    mounted: function() {}
};
</script>


// WEBPACK FOOTER //
// BlockTraineesAwards.vue?7cf140d8